export default "/images/vendor/flag-icon-css/flags/4x3/nu.svg?e4a214a98aad840d08817821bf1a85d1";